var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuProcessing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g827",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.258,
    height: 23.258,
    viewBox: "0 0 23.258 23.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path831",
    d: "M0-682.665H23.258v23.258H0Z",
    transform: "translate(0 682.665)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g829",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g835",
    transform: "translate(4.94 6.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path837",
    d: "M-79.788-92.542a2.241,2.241,0,0,1-2.158-.583,2.243,2.243,0,0,1-.371-2.682",
    transform: "translate(82.602 95.806)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g839",
    transform: "translate(6.396 4.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path841",
    d: "M0-4.018A2.242,2.242,0,0,1,2.371-3.5a2.241,2.241,0,0,1,.583,2.158",
    transform: "translate(0 4.16)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g843",
    transform: "translate(0.336 0.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path845",
    d: "M-368.835-166.848h-.568a.252.252,0,0,1-.246-.2,5.441,5.441,0,0,0-.745-1.8.252.252,0,0,1,.033-.315l.706-.706a.252.252,0,0,0,0-.356l-1-1a.252.252,0,0,0-.356,0l-.706.706a.252.252,0,0,1-.315.033,5.443,5.443,0,0,0-1.8-.745.252.252,0,0,1-.2-.246v-1a.252.252,0,0,0-.252-.252h-1.418a.252.252,0,0,0-.252.252v1a.252.252,0,0,1-.2.246,5.442,5.442,0,0,0-1.8.745.252.252,0,0,1-.315-.033l-.706-.706a.252.252,0,0,0-.356,0l-1,1a.252.252,0,0,0,0,.356l.706.706a.252.252,0,0,1,.033.315,5.438,5.438,0,0,0-.745,1.8.252.252,0,0,1-.246.2h-1a.252.252,0,0,0-.252.252v1.418a.252.252,0,0,0,.252.252h1a.252.252,0,0,1,.246.2,5.438,5.438,0,0,0,.745,1.8.252.252,0,0,1-.033.315l-.706.706a.252.252,0,0,0,0,.356l1,1a.252.252,0,0,0,.356,0l.706-.706a.252.252,0,0,1,.315-.033,5.44,5.44,0,0,0,1.8.745.252.252,0,0,1,.2.246v.5",
    transform: "translate(381.844 172.733)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g847",
    transform: "translate(12.136 12.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path849",
    d: "M-112.079-112.079a2.316,2.316,0,0,1-3.275,0,2.316,2.316,0,0,1,0-3.275,2.316,2.316,0,0,1,3.275,0A2.316,2.316,0,0,1-112.079-112.079Z",
    transform: "translate(116.032 116.032)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g851",
    transform: "translate(10.419 10.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path853",
    d: "M-9.076-159.046a4.034,4.034,0,0,1,.861-4.429,4.032,4.032,0,0,1,5.7,0,4.032,4.032,0,0,1,0,5.7,4.032,4.032,0,0,1-5.666.036",
    transform: "translate(9.397 164.656)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g855",
    transform: "translate(5.981 5.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path857",
    d: "M-392.382-427.556l1.241-1.241a.312.312,0,0,0,0-.441l-.873-.873a.312.312,0,0,1-.041-.39,6.733,6.733,0,0,0,.922-2.228.312.312,0,0,1,.3-.248h1.236a.312.312,0,0,0,.312-.312v-1.754a.312.312,0,0,0-.312-.312h-1.236a.312.312,0,0,1-.3-.248,6.733,6.733,0,0,0-.922-2.228.312.312,0,0,1,.041-.39l.873-.873a.312.312,0,0,0,0-.441l-1.241-1.241a.312.312,0,0,0-.441,0l-.873.873a.312.312,0,0,1-.39.041,6.732,6.732,0,0,0-2.228-.922.312.312,0,0,1-.248-.3v-1.236a.312.312,0,0,0-.312-.312h-1.754a.312.312,0,0,0-.312.312v1.236a.312.312,0,0,1-.248.3,6.731,6.731,0,0,0-2.228.922.312.312,0,0,1-.39-.041l-.873-.873a.312.312,0,0,0-.441,0l-1.241,1.241a.312.312,0,0,0,0,.441l.873.873a.312.312,0,0,1,.041.39,6.732,6.732,0,0,0-.922,2.228.312.312,0,0,1-.3.248h-1.236a.312.312,0,0,0-.312.312v1.754a.312.312,0,0,0,.312.312h1.236a.312.312,0,0,1,.3.248,6.733,6.733,0,0,0,.922,2.228.312.312,0,0,1-.041.39l-.873.873a.312.312,0,0,0,0,.441l1.241,1.241a.312.312,0,0,0,.441,0l.873-.873a.312.312,0,0,1,.39-.041,6.73,6.73,0,0,0,2.228.922.312.312,0,0,1,.248.3v1.236a.312.312,0,0,0,.312.312h1.754a.312.312,0,0,0,.312-.312v-1.236a.312.312,0,0,1,.248-.3,6.732,6.732,0,0,0,2.228-.922.312.312,0,0,1,.39.041l.873.873A.312.312,0,0,0-392.382-427.556Z",
    transform: "translate(406.222 442.636)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuProcessing);
export default __webpack_public_path__ + "static/media/icon_menu_processing.0a5a83d6dc9e2f2b36aefe080beb5bb9.svg";
export { ForwardRef as ReactComponent };